import { render, staticRenderFns } from "./ViewSettingsRagicBudget.vue?vue&type=template&id=477d6b5b&scoped=true&"
import script from "./ViewSettingsRagicBudget.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsRagicBudget.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsRagicBudget.vue?vue&type=style&index=0&id=477d6b5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d6b5b",
  null
  
)

export default component.exports